import { useState, useEffect } from 'react';
import { apiGet } from '../lib/apiClient';

interface HistoryItem {
    id: number;
    operation_id: string;
    old_asset_text: string;
    new_asset_text: string;
    operation_type: string;
    replace_reason: string;
    executed_at: string;
    success: number;
    criminal_type?: string;
    tier_level?: string;
}

export function DeployLog() {
    const [loading, setLoading] = useState(true);
    const [history, setHistory] = useState<HistoryItem[]>([]);

    useEffect(() => {
        loadHistory();
    }, []);

    async function loadHistory() {
        try {
            const res = await apiGet('/api/deploy/history');
            const data = await res.json();
            if (data.success) {
                setHistory(data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <div className="loading"><div className="spinner"></div></div>;
    }

    return (
        <div>
            <h2 style={{ marginBottom: '1.5rem' }}>📋 部署歷史</h2>

            {history.length === 0 ? (
                <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
                    <p style={{ color: 'var(--color-text-secondary)' }}>
                        尚無部署記錄
                    </p>
                </div>
            ) : (
                <div className="card">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid var(--color-border)' }}>
                                <th style={{ padding: '1rem', textAlign: 'left' }}>時間</th>
                                <th style={{ padding: '1rem', textAlign: 'left' }}>操作</th>
                                <th style={{ padding: '1rem', textAlign: 'left' }}>舊文案</th>
                                <th style={{ padding: '1rem', textAlign: 'left' }}>新文案</th>
                                <th style={{ padding: '1rem', textAlign: 'center' }}>狀態</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((item) => (
                                <tr
                                    key={item.id}
                                    style={{ borderBottom: '1px solid var(--color-border)' }}
                                >
                                    <td style={{ padding: '1rem', fontSize: '0.875rem' }}>
                                        {new Date(item.executed_at).toLocaleString('zh-TW')}
                                    </td>
                                    <td style={{ padding: '1rem' }}>
                                        <span style={{
                                            fontSize: '0.75rem',
                                            padding: '0.25rem 0.5rem',
                                            background: 'var(--color-surface)',
                                            borderRadius: '4px'
                                        }}>
                                            {item.operation_type.replace('RSA_', '').replace('_REPLACE', '')}
                                        </span>
                                    </td>
                                    <td style={{
                                        padding: '1rem',
                                        maxWidth: '200px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: 'var(--color-danger)',
                                        fontFamily: 'monospace',
                                        fontSize: '0.875rem'
                                    }}>
                                        {item.old_asset_text}
                                    </td>
                                    <td style={{
                                        padding: '1rem',
                                        maxWidth: '200px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        color: 'var(--color-success)',
                                        fontFamily: 'monospace',
                                        fontSize: '0.875rem'
                                    }}>
                                        {item.new_asset_text}
                                    </td>
                                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                                        {item.success ? (
                                            <span style={{ color: 'var(--color-success)' }}>✅</span>
                                        ) : (
                                            <span style={{ color: 'var(--color-danger)' }}>❌</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
